<template>
    <div>
        <div v-if="purchaseComplete">
            <refill-complete />
        </div>
        <div v-else>
            <refill-methods />
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";

import RefillMethods from "@/components/wallet/refill/RefillMethods";
import RefillComplete from "@/components/wallet/refill/RefillComplete";

export default {
    computed: {
        ...mapState("wallet", ["purchaseComplete"]),
        ...mapState({
            onboardingUser: (state) => state.onboarding.user,
        }),
    },
    components: {
        RefillMethods,
        RefillComplete,
    },
};
</script>